import React from "react";
import { useRouter } from "next/router";
import Box from "@mui/material/Box";

import Header from "../header";
// import { useRouter } from "next/dist/client/router";
import { LayoutStyled } from "./layoutStyled";

interface ILayout {
  children: React.ReactNode;
}
/**
 * Pages that use the full window width instead of the 1250px centred column.
 * These are dense, table- and chart-heavy screens where the fixed column wastes
 * most of a wide monitor.
 */
const FULL_WIDTH_ROUTES = ["/roster", "/reports", "/reports/quarterly"];

const Layout = ({ children }: ILayout) => {
  const router = useRouter();
  const { pathname } = router;
  const isFullWidth = FULL_WIDTH_ROUTES.includes(pathname);
  const isAlert = pathname === "/alert";

  return (
    <LayoutStyled>
      <div>
        <Header />
        <div></div>
        <main
          className={isAlert ? "alert" : isFullWidth ? "roster" : "banner"}
          style={{
            marginTop: "0px",
          }}
        >
          <Box
            className={
              isAlert ? "alert" : isFullWidth ? "roster" : "other-pages"
            }
            sx={{
              width: "100%",
              maxWidth: isFullWidth || isAlert ? "none" : "1250px",
              margin: "0 auto",
              px: { xs: 2, sm: 2, lg: 0 },
              boxSizing: "border-box",
            }}
          >
            {children}
          </Box>
        </main>
      </div>
    </LayoutStyled>
  );
};

export default Layout;
